import { useParams } from 'react-router-dom';
import { Typography } from '@mui/material';
import { Loader } from 'src/components';
import TabsPageLayout from 'src/components/TabsPageLayout';
import { useDeploymentRing } from 'src/hooks/deploymentRing';
import { DEPLOYMENT_RINGS_ROUTE } from 'src/pages/environment/constants';
import { deploymentRingDetailsTabs } from './constants';

const DeploymentRingDetailsPage = () => {
  const { ringId } = useParams();
  const { data: ring, isLoading } = useDeploymentRing({ ringId });

  // Only the first load takes over the page - a refetch after an edit must not unmount the tab,
  // or the dialogs it owns would vanish mid-save.
  if (isLoading) {
    return <Loader />;
  }

  if (!ring) {
    return <Typography>Deployment ring not found.</Typography>;
  }

  return (
    <TabsPageLayout
      hasBackButton
      backNavigationPath={DEPLOYMENT_RINGS_ROUTE}
      title={ring.name}
      tabs={deploymentRingDetailsTabs(ringId)}
      outletContext={{ ring }}
      wrapperProps={{
        sx: {
          maxWidth: '100%',
        },
      }}
      titleProps={{
        fontSize: '1.4rem',
      }}
    />
  );
};

export default DeploymentRingDetailsPage;
